import React, { useState, type JSX } from 'react'
import classnames from 'classnames'
import { LegacyInputRef } from '../../../types/legacyInputRef'

export type RangeInputProps = {
  id: string
  name: string
  min?: number
  max?: number
  textPreposition?: string
  textUnit?: string
  inputRef?: LegacyInputRef
  wrapperClassName?: string
} & JSX.IntrinsicElements['input']

export const RangeInput = ({
  className,
  wrapperClassName,
  inputRef,
  textPreposition,
  textUnit,
  ...inputProps
}: RangeInputProps): JSX.Element => {
  const inputClasses = classnames('usa-range', className)
  const wrapperClasses = classnames('usa-range__wrapper', wrapperClassName)
  // input range defaults to min = 0, max = 100, step = 1, and value = (max/2) if not specified.
  const defaultMin = 0
  const defaultMax = 100
  const defaultVal = Math.round(defaultMax / 2)
  const defaultUnit = ''
  const defaultPreposition = 'of'
  const {
    min,
    max,
    defaultValue,
    value: valueProp,
    ...remainingInputProps
  } = inputProps
  const rangeMin = min || defaultMin
  const rangeMax = max || defaultMax
  const rangeUnit = textUnit || defaultUnit
  const rangePreposition = textPreposition || defaultPreposition
  const rangeValue =
    valueProp !== undefined
      ? valueProp
      : defaultValue !== undefined
        ? defaultValue
        : defaultVal
  const [value, setValue] = useState(rangeValue)
  const callout = `${value.toString()} ${rangeUnit} ${rangePreposition} ${rangeMax}`

  return (
    <div data-testid="range-wrapper" className={wrapperClasses}>
      <input
        data-testid="range"
        aria-valuetext={callout}
        className={inputClasses}
        ref={inputRef}
        type="range"
        {...remainingInputProps}
        min={rangeMin}
        max={rangeMax}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
      />
      <span
        data-testid="range-visual"
        aria-hidden="true"
        className="usa-range__value">
        {value}
      </span>
    </div>
  )
}

export default RangeInput
